'use strict';

import angular from "angular";

import "./Api";

export default angular.module('Token',['fastx.Api'])
.factory('Token',['$window','Api','$rootScope',function($window,Api,$rootScope){
	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + "; " + expires;
	}
	function getCookie(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	function refresh(success,error){
		Api.post('api/keepalive',{},{},function(d){
			success = success || function(){};
			error = error || function(){};

			$window.localStorage['token'] = d.token;
			$window.localStorage['username'] = d.username;
			if(d.host){
				$window.localStorage['host'] = d.host;
			}else{
				delete $window.localStorage['host'];
			}
			$rootScope.pageTitle = $window.localStorage['username']
			if($window.localStorage['host']){
				$rootScope.pageTitle += '@' + $window.localStorage['host'];
			}
			$rootScope.username = $window.localStorage['username'] ||'nobody';
			success(d)
		},function(e){
			remove();
			if(error){error(e)};
		});
	}
	function remove(){
		setCookie('token','',0);
		$window.localStorage.removeItem('token');
		$window.sessionStorage.removeItem('motd');
	}
	function getFromServer(success,error){
		Api.post('api/token',{},function(d){
			if(d.error){
				remove();
				if(error){error(d.error)};
			}else{
				$window.localStorage['token'] = d.token;
				$window.localStorage['username'] = d.username;
				$window.localStorage['host'] = d.host;
				success(d);
			}
		},function(e){
			remove();
			if(error){error(e)};
		});
	}
	var t = {};
	t.refresh = refresh;
	t.remove = remove;
	t.getFromServer = getFromServer;
	Object.defineProperty(t,'token',{
		set:function(myToken){$window.localStorage['token'] = myToken;},
		get:function(){return $window.localStorage['token'] || getCookie('token');}
	});
	return t;
}]);



//////////////////
// WEBPACK FOOTER
// ../common/Token.js
// module id = 3
// module chunks = 0